export interface RtuIdentitySource {
  rtuHeader?: {
    serialNo?: string | null;
  } | null;
  serialNo?: string | null;
}

const normalizeIdentityValue = (value: string | null | undefined): string | null => {
  const normalized = String(value ?? '').trim();
  return normalized || null;
};

/**
 * Supports both the canonical top-level DTO property and the nested legacy
 * header during rolling frontend/backend deployments.
 */
export const resolveRtuSerialNo = (rtu: RtuIdentitySource | null | undefined): string | null =>
  normalizeIdentityValue(rtu?.serialNo) ?? normalizeIdentityValue(rtu?.rtuHeader?.serialNo);
